import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { UserProvider } from './context/UserContext';
import IntroPage from './pages/IntroPage';
import LoginScreen from './pages/auth/LoginScreen';
import OTPVerificationScreen from './pages/auth/OTPVerificationScreen';
import AdditionalDetailsScreen from './pages/auth/AdditionalDetailsScreen';
import Dashboard from './pages/dashboard/Dashboard';
import AppointmentDetailsScreen from './pages/dashboard/AppointmentDetailsScreen';
import ManageServicesScreen from './pages/dashboard/ManageServicesScreen';
import EditProfileScreen from './pages/dashboard/EditProfileScreen';
import NotificationScreen from './pages/dashboard/NotificationScreen';
import PastAppointmentsScreen from './pages/dashboard/PastAppointmentsScreen';
import AppointmentsPage from './pages/dashboard/AppointmentsPage';
import ProfileScreen from './pages/dashboard/ProfileScreen';
import CompleteProfileScreen from './pages/dashboard/CompleteProfileScreen';
import AboutUsScreen from './pages/public/AboutUsScreen';
import ContactUsScreen from './pages/dashboard/ContactUsScreen';
import UpdateProfilePictureScreen from './pages/dashboard/UpdateProfilePictureScreen';
import UpdateLocationScreen from './pages/dashboard/UpdateLocationScreen';
import EarningsScreen from './pages/dashboard/EarningsScreen';
import ManageSpecializationsScreen from './pages/dashboard/ManageSpecializationsScreen';
import ManageOpeningHoursScreen from './pages/dashboard/ManageOpeningHoursScreen';
import ConsultationFeeScreen from './pages/dashboard/ConsultationFeeScreen';
import ReviewAndRatingScreen from './pages/dashboard/ReviewAndRatingScreen';
import FAQScreen from './pages/public/FAQScreen';
import PrivacyPolicyScreen from './pages/public/PrivacyPolicyScreen';
import TermsAndConditionsScreen from './pages/public/TermsAndConditionsScreen';
import PublicContactUsScreen from './pages/public/PublicContactUsScreen';
import ProtectedRoute from './components/ProtectedRoute';

import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <UserProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<IntroPage />} />
            <Route path="/faq" element={<FAQScreen />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyScreen />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditionsScreen />} />
            <Route path="/contact-us" element={<PublicContactUsScreen />} />
            <Route path="/about-us" element={<AboutUsScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/otp-verification" element={<OTPVerificationScreen />} />
            <Route path="/additional-details" element={<AdditionalDetailsScreen />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/appointment/:id" 
              element={
                <ProtectedRoute>
                  <AppointmentDetailsScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/manage-services" 
              element={
                <ProtectedRoute>
                  <ManageServicesScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/edit-profile" 
              element={
                <ProtectedRoute>
                  <EditProfileScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/notifications" 
              element={
                <ProtectedRoute>
                  <NotificationScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/past-appointments" 
              element={
                <ProtectedRoute>
                  <PastAppointmentsScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/appointments" 
              element={
                <ProtectedRoute>
                  <AppointmentsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <ProfileScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/complete-profile" 
              element={
                <ProtectedRoute>
                  <CompleteProfileScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/about-us" 
              element={
                <ProtectedRoute>
                  <AboutUsScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/contact" 
              element={
                <ProtectedRoute>
                  <ContactUsScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/update-profile-picture" 
              element={
                <ProtectedRoute>
                  <UpdateProfilePictureScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/update-location" 
              element={
                <ProtectedRoute>
                  <UpdateLocationScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/earnings" 
              element={
                <ProtectedRoute>
                  <EarningsScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/manage-specializations" 
              element={
                <ProtectedRoute>
                  <ManageSpecializationsScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/manage-opening-hours" 
              element={
                <ProtectedRoute>
                  <ManageOpeningHoursScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/consultation-fees" 
              element={
                <ProtectedRoute>
                  <ConsultationFeeScreen />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/reviews" 
              element={
                <ProtectedRoute>
                  <ReviewAndRatingScreen />
                </ProtectedRoute>
              } 
            />

          </Routes>
          
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;